import React from 'react';
import { Button } from './ui/button';
import { Send, Mail } from 'lucide-react';
import { siteContent } from '../mockData';
import { useTranslation } from 'react-i18next';
import LatamMapBackground from './LatamMapBackground';

const Hero = () => {
  const { contact } = siteContent;
  const { t } = useTranslation();

  const handleTelegram = () => {
    window.open(contact.telegram, '_blank');
  };

  const handleEmail = () => {
    window.location.href = `mailto:${contact.email}`;
  };

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628] via-[#0D1F40] to-[#0A1628]">
        <div className="absolute inset-0 opacity-20" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2300D4FF' fill-opacity='0.1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
        
        {/* LATAM Map - d3-geo rendered from real TopoJSON data */}
        <LatamMapBackground />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 lg:px-8 py-32 text-center">
        <h1 className="animate-in fade-in slide-in-from-bottom-4 duration-700 !font-sans !font-bold !text-xl !italic md:!text-2xl mb-6 text-[#00D4FF]">CryPT-BR</h1>
        <h2 data-testid="hero-title" className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100">
          {t('hero.title')}
        </h2>
        <p data-testid="hero-subtitle" className="max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-700 delay-200 !text-2xl mx-auto mb-12 text-gray-300">
          {t('hero.subtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-300">
          <Button
            data-testid="hero-telegram-btn"
            onClick={handleTelegram}
            className="bg-[#F5C518] hover:bg-[#00E5A0] text-black font-bold px-8 py-6 text-lg rounded-md transition-all duration-200 hover:scale-105 shadow-lg shadow-[#F5C518]/30 hover:shadow-[#00E5A0]/40 flex items-center gap-2">
            <Send size={20} />
            {t('hero.telegram')}
          </Button>
          <Button
            data-testid="hero-email-btn"
            onClick={handleEmail}
            variant="outline"
            className="border-2 border-[#00D4FF] text-[#00D4FF] hover:bg-[#00D4FF] hover:text-black font-bold px-8 py-6 text-lg rounded-md transition-all duration-200 hover:scale-105 flex items-center gap-2">
            <Mail size={20} />
            {t('hero.email')}
          </Button>
        </div>

        <p data-testid="hero-note" className="animate-in fade-in duration-700 delay-400 !text-base text-gray-400">
          {t('hero.note')}
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>);

};

export default Hero;